
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-car-offers",
      function () {
        return require("private-next-pages/new-car-offers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-car-offers"])
      });
    }
  